import { Carousel } from "../components/Carousel/Carousel";
import { useTranslation } from "react-i18next";
import { FadeInOnScroll } from "../components/FadeInOnScoll/FadeInOnScroll";

export const Videos = () => {
  const { t } = useTranslation();

  return (
    <section
      className="pt-16 bg-gray relative z-10 pb-20"
      style={{
        clipPath: "polygon(0 0, 100% 0, 100% 90%, 0 100%)",
      }}
    >
      <FadeInOnScroll>
        <h4 id="video" className="title-page">
          {t("video")}
        </h4>
      </FadeInOnScroll>
      <FadeInOnScroll delay={200}>
        <Carousel />
      </FadeInOnScroll>
    </section>
  );
};
